import { render } from "./BillIndex.vue?vue&type=template&id=177dfe62"
import script from "./BillIndex.vue?vue&type=script&lang=js"
export * from "./BillIndex.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/p878kMc7/0/softbot/pplotto/pplotto-v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QBreadcrumbs from 'quasar/src/components/breadcrumbs/QBreadcrumbs.js';
import QBreadcrumbsEl from 'quasar/src/components/breadcrumbs/QBreadcrumbsEl.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPagination from 'quasar/src/components/pagination/QPagination.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QBreadcrumbs,QBreadcrumbsEl,QSpace,QInput,QIcon,QPopupProxy,QDate,QBtn,QSelect,QTable,QTh,QInnerLoading,QTd,QPagination});
